import instanceQuery from 'graphql/queries/system/SystemLicenseQuery.graphql';
import defaultQuery from 'graphql/queries/system/SystemLicenseQuery.graphql';
import mutationQuery from 'graphql/mutations/system/SystemLicenseMutation.graphql';
import fragment from 'graphql/fragments/system/SystemLicenseFragment.graphql';

const SystemLicense = {
  type: 'License',
  title: 'System License',
  formTitle: 'System License',
  formUrl: '/System/SystemLicense/',
  instance: instanceQuery,
  default: defaultQuery,
  update: mutationQuery,
  fragment,
  screenReference: 'SYSTEM_LICENSE',
};

export default SystemLicense;
